import { initClubMenu } from "./components/club-menu.js";
import { observeStickyPageHeaders } from "./components/page-header.js";
import { squareFonts } from "./components/title-page.js";

function announce(context) {
  once("titan-rwe-announce", "body", context).forEach((el) => {
    console.log("It works! TITAN RWE");
  });
}

/**
 * @file
 * Titan-RWE behaviors.
 */
(function (Drupal) {
  "use strict";

  Drupal.behaviors.titanRwe = {
    attach(context, settings) {
      announce(context);
      initClubMenu(context);
      observeStickyPageHeaders(context);
      squareFonts(context);
    },
  };
})(Drupal);
